var _line, _line2, _line3, _line4, _line5, _line6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTableViewIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 14,
    viewBox: "0 0 17 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    y1: 0.5,
    x2: 17,
    y2: 0.5,
    stroke: "#0071B6"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    y1: 1,
    x2: 17,
    y2: 1,
    stroke: "#0071B6",
    strokeWidth: 2
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    y1: 4,
    x2: 17,
    y2: 4,
    stroke: "#0071B6",
    strokeWidth: 2
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    y1: 7,
    x2: 17,
    y2: 7,
    stroke: "#0071B6",
    strokeWidth: 2
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    y1: 10,
    x2: 17,
    y2: 10,
    stroke: "#0071B6",
    strokeWidth: 2
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    y1: 13,
    x2: 17,
    y2: 13,
    stroke: "#0071B6",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTableViewIcon);
export default __webpack_public_path__ + "static/media/TableViewIcon.48a37fc04fb85d068bc3693b12b2f0fc.svg";
export { ForwardRef as ReactComponent };